import React from 'react';
import { Link } from 'react-router-dom';
import { Button,Table,Modal } from 'antd';
import abortAjaxHoc from 'components/abortAjaxHoc';
import ControlSeparator from 'components/ControlSeparator';

class LiteScenesList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            list: [],
            loading:true
        };
        this.columns = [
            {
                title: 'Scenes ID',
                dataIndex: 'scene_id',
                key: 'scene_id',
                width: '25%'
            }, {
                title: 'Scenes Name',
                dataIndex: 'scene_name',
                key: 'scene_name',
                width: '25%'
            }, {
                title: 'Scenes Describe',
                dataIndex: 'scene_description',
                key: 'scene_description',
                width: '25%'
            }, {
                title: 'Operate',
                dataIndex: 'id',
                key: 'id',
                width: 100,
                render: (id,item) => {
                    return (
                        <ControlSeparator>
                            <Link to={'/pages/lite-scenes/edit/' + id}>edit</Link>
                            <a onClick={this.onDelete.bind(this,id,item)}>delete</a>
                        </ControlSeparator>
                    );

                }
            }, {
                title: 'Default',
                dataIndex: 'id',
                key: 'id_control',
                width: 100,
                sorter: (a,b) => {
                    return  b.is_default - a.is_default;
                },
                render: (id, item) => {
                    return item.is_default ? <div>
                        <span style={{ color: 'green' }}> Default </span>
                        <a className="unset-default" onClick={this.unSetDefault.bind(this, item.id)}> Unset as Default </a>
                    </div> : <a className="set-to-default" onClick={this.setDefault.bind(this, item.id)}>Set as Default</a>;

                }
            }
        ];
    }

    componentDidMount(){
        this.getList();
    }

    onDelete = (id,row)=>{
        Modal.confirm({
            title:`Are you sure to delete:"${row.scene_name}"?`,
            onOk:()=>{
                this.setState({ loading: true });
                this.props.abortableAjax('PUT','/lite_scene/'+id,{is_deleted: 1}).then(()=>{
                    this.getList();
                }).catch(()=>{
                    this.setState({ loading: false });
                });
            }
        });
    }

    setDefault(id) {
        this.setState({ loading: true });
        this.props.abortableAjax('PUT','/lite_scene/'+id,{ is_default: 1 }).then(()=>{
            this.getList();
        }).catch(()=>{
            this.setState({ loading: false });
        });;
    }

    unSetDefault(id) {
        this.setState({ loading: true });
        this.props.abortableAjax('PUT','/lite_scene/'+id,{ is_default: 0 }).then(()=>{
            this.getList();
        }).catch(()=>{
            this.setState({ loading: false });
        });;
    }

    getList = ()=>{
        const _params = {
            region:'oversea'
        };
        this.setState({loading:true});
        return this.props.abortableAjax('GET','/lite_scene',_params).then(res=>{
            const data = res.data;
            let lites = [];
            if(res && data.reverse){
                lites = data.reverse();
            }
            this.setState({list:lites,loading:false});
        });
    }

    render() {
        return (
            <div>
                <Link to="/pages/lite-scenes/create">
                    <Button type="primary" style={{margin:'10px 0'}}>New H5 Config Scene</Button>
                </Link>
                <Table
                    loading={this.state.loading}
                    rowKey='scene_id'
                    columns={this.columns}
                    dataSource={this.state.list}
                    onSubmit={this.onStart}
                    pagination={{pageSize:20}}
                />
            </div>);
    }
}


export default abortAjaxHoc(LiteScenesList);



// WEBPACK FOOTER //
// ./src/pages/LiteScenes/LiteScenesList.js